__turbopack_context__.v({
  "container": "Chevron-module__0ORxfG__container",
});
